import { render, staticRenderFns } from "./gauge.vue?vue&type=template&id=c7fed52a&scoped=true"
import script from "./gauge.vue?vue&type=script&lang=js"
export * from "./gauge.vue?vue&type=script&lang=js"
import style0 from "./gauge.vue?vue&type=style&index=0&id=c7fed52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fed52a",
  null
  
)

export default component.exports